import * as React from 'react';
import * as S from './sidebar-divider.styles';

export class SidebarDivider extends React.PureComponent<{}> {
    public render(): React.ReactElement {
        return <S.SidebarDivider />;
    }
}
